import { Injectable, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of, Subject} from 'rxjs';
import {ConfigService} from './config.service';
import {LanguageService} from './language.service';

@Injectable({
  providedIn: 'root'
})
export class TextService {
  public subject = new Subject<string>();

  private translateService = inject(TranslateService);
  private configService = inject(ConfigService);

  getSubject(): Observable<string> {
    return this.subject.asObservable();
  }

  get(slug: string): Observable<string> {
    try {
      const textFromConfig = this.configService.getConfig().texts[this.getCurrentLanguage()][slug];

      if (!textFromConfig && textFromConfig !== '') {
        return this.translateService.get(slug);
      }
      return of(textFromConfig);
    } catch {
      return this.translateService.get(slug);
    }
  }

  getCurrentLanguage(): string {
    return LanguageService.getCurrentLanguage().toUpperCase();
  }
}
